import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, input, ViewEncapsulation } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MarkdownModule } from 'ngx-markdown'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Media } from '../../enums/enums'
import { Figure } from '../../models/main/figure'
import { DdcPrivacyComponent } from '../ddc-privacy/ddc-privacy.component'
import { DdcProfilePicComponent } from '../ddc-profile-pic/ddc-profile-pic.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-read-figure-mobile-sheet',
  templateUrl: './ddc-read-figure-mobile-sheet.component.html',
  styleUrls: ['./ddc-read-figure-mobile-sheet.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    DdcPrivacyComponent,
    DdcTextGradientComponent,
    DdcProfilePicComponent,
    MarkdownModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcReadFigureMobileSheetComponent {
  figure = input<Figure>(undefined)

  // Profile picture properties
  _dynamicRoute: string = ''
  _isProfilePicLoading: boolean = false
  _userProfilePic: string = ''

  _assets = Media.ASSETS
  _showLightbox = false

  getFigurePicUrl(url: string | undefined): string {
    if (!url) return ''
    if (url.startsWith('http')) {
      // Extract path after /media/ and use proxied assets path
      const mediaIndex = url.indexOf('/media/')
      return mediaIndex !== -1 ? Media.ASSETS + url.slice(mediaIndex) : url
    }
    return Media.ASSETS + url
  }

  _isDarkTheme = false
  _isLightTheme = true
  _isPaperTheme = false

  constructor(
    private readDialogRef: MatDialogRef<DdcReadFigureMobileSheetComponent>,
    private _themeService: ThemeService,
  ) {
    this._themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === 'dark-theme'
      this._isLightTheme = theme === 'light-theme'
      this._isPaperTheme = theme === 'paper-theme'
    })

    // React to note changes
    effect(() => {
      this.setupProfilePicData()
    })
  }

  private setupProfilePicData(): void {
    // This will need to be updated based on how you get the user data
    // For now, setting default values
    const currentFigure = this.figure()
    if (currentFigure?.owner) {
      this._dynamicRoute = `/users/${currentFigure.owner.username || ''}`
      this._userProfilePic = currentFigure.owner.profile_pic || ''
      this._isProfilePicLoading = false
    }
  }

  protected onProfilePicClick(): void {
    this.readDialogRef.close()
  }
}
